module.exports = __webpack_public_path__ + "img/tower_of_elder_knowledge_small.843dea5c.png";